/** @format */

import React, { useState } from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import ValidityCheck from "./validityCheck";

const DateInput = ({ id, control, errors, showValidIcon }) => {
  const [isInputClicked, setIsInputClicked] = useState(true);

  return (
    <Controller
      name={id}
      control={control}
      rules={{ required: true }}
      render={({ field }) => (
        <div className="tw-relative tw-py-[15px]">
          <DatePicker
            wrapperClassName="tw-mt-[-1px]"
            onClick={() => setIsInputClicked(!isInputClicked)}
            data-clicked={isInputClicked ? "true" : "false"}
            placeholderText="MM/DD/YYYY"
            onChange={(date) => field.onChange(date)}
            selected={field.value}
            dateFormat="MM/dd/yyyy"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            className={`tw-box-border tw-h-12 tw-w-full tw-rounded-lg tw-border-0 tw-border-b-2 tw-border-solid ${errors ? "tw-border-dis-error tw-bg-dis-error-bg" : "tw-border-dis-field-edge tw-bg-dis-field hover:tw-bg-dis-field-hover focus:tw-outline-[3px] focus:tw-outline-dis-navy focus:tw-outline-offset-2 focus:tw-shadow-dis-focus"} tw-py-[5px] tw-pl-[15px] tw-text-base tw-text-dis-navy placeholder:tw-text-dis-placeholder`}
          />
          {showValidIcon && <ValidityCheck />}
        </div>
      )}
    />
  );
};

export default DateInput;
